<script setup lang="ts">
import { AppMultiSelect } from '@shared/ui/selects'

import {
  useSelectChangeReason,
} from '../../../../model/additional-info/support/info-change-tutor/select-change-reason.hook'

defineOptions({
  name: 'SelectChangeReason',
})

const {
  placeholder,
  model,
  options,
} = useSelectChangeReason()
</script>

<template>
  <AppMultiSelect
    v-model="model"
    :options="options"
    :placeholder="placeholder"
    clearable
  />
</template>
